import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Heading from 'components/Heading';
import Icon from 'components/Icon';
import FriendlyDuration from 'components/FriendlyDuration';
import Button from 'components/Button';
import TextLink from 'components/TextLink';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function QuoteBlock(_ref) {
  var skillId = _ref.skillId,
    quotes = _ref.quotes,
    title = _ref.title,
    getLocation = _ref.getLocation;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var displayedQuotes = showMore || quotes.length <= 1 ? quotes : [quotes[0]];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h4",
      size: "small",
      mb: "xs",
      children: title
    }), /*#__PURE__*/_jsx(Stack, {
      spacing: "s",
      children: displayedQuotes.map(function (quote, index) {
        var text = quote.text,
          reasoning = quote.reasoning,
          startTime = quote.startTime,
          meetingTitle = quote.meetingTitle,
          meetingId = quote.meetingId;
        var hasInvalidStartTime = typeof startTime !== 'number' || isNaN(startTime);
        return /*#__PURE__*/_jsx(Fragment, {
          children: /*#__PURE__*/_jsxs(Stack, {
            spacing: "xxs",
            children: [/*#__PURE__*/_jsxs(_Fragment, {
              children: [meetingTitle && /*#__PURE__*/_jsxs(_Fragment, {
                children: [meetingId && getLocation ? /*#__PURE__*/_jsx(TextLink, {
                  bold: true,
                  as: Link,
                  to: getLocation({
                    meetingId: meetingId,
                    searchSkillId: skillId
                  }),
                  children: meetingTitle
                }) : /*#__PURE__*/_jsx(Text, {
                  bold: true,
                  children: meetingTitle
                }), hasInvalidStartTime && /*#__PURE__*/_jsx(Text, {
                  bold: true,
                  mr: "xxs",
                  children: ":"
                })]
              }), meetingTitle && !hasInvalidStartTime && /*#__PURE__*/_jsx(Text, {
                mx: "xxs",
                bold: true,
                children: "-"
              }), !hasInvalidStartTime && /*#__PURE__*/_jsxs(Text, {
                bold: true,
                mr: "xxs",
                children: [/*#__PURE__*/_jsx(FriendlyDuration, {
                  value: startTime,
                  showSeconds: true
                }), ":"]
              }), /*#__PURE__*/_jsxs(Text, {
                style: {
                  fontStyle: 'italic'
                },
                children: ["\"", text, "\""]
              })]
            }), /*#__PURE__*/_jsx(Text, {
              children: reasoning
            })]
          })
        }, "".concat(text, "-").concat(index));
      })
    }), quotes.length > 1 && /*#__PURE__*/_jsx(Button, {
      mt: "xs",
      variant: "transparent",
      size: "small",
      onClick: function onClick() {
        return setShowMore(!showMore);
      },
      icon: /*#__PURE__*/_jsx(Icon, {
        name: "chevron",
        rotate: showMore ? -180 : 0
      }),
      children: t(showMore ? 'actions_show_less' : 'actions_show_more')
    })]
  });
}
function QuoteSection(_ref2) {
  var skillId = _ref2.skillId,
    positiveSkillUsage = _ref2.positiveSkillUsage,
    negativeSkillUsage = _ref2.negativeSkillUsage,
    getLocation = _ref2.getLocation;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "s",
    children: [(positiveSkillUsage === null || positiveSkillUsage === void 0 ? void 0 : positiveSkillUsage.length) > 0 && /*#__PURE__*/_jsx(QuoteBlock, {
      skillId: skillId,
      title: t('property_positive_relevant_quotes'),
      quotes: positiveSkillUsage,
      getLocation: getLocation
    }), (negativeSkillUsage === null || negativeSkillUsage === void 0 ? void 0 : negativeSkillUsage.length) > 0 && /*#__PURE__*/_jsx(QuoteBlock, {
      skillId: skillId,
      title: t('property_negative_relevant_quotes'),
      quotes: negativeSkillUsage,
      getLocation: getLocation
    })]
  });
}
export default QuoteSection;